import React from 'react';
import classnames from 'classnames';
import cls from './Tooltip.module.scss';

export type TooltipProps = {
  children: React.ReactNode;
  type?: 'default' | 'error';
  clsName?: string;
};
export const Tooltip = ({
  children,
  type = 'default',
  clsName,
}: TooltipProps) => {
  const typeCls = {
    default: '',
    error: cls.tooltipError,
  }[type];

  return (
    <div className={classnames(cls.tooltip, typeCls, clsName)}>{children}</div>
  );
};
